<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Accreditor Name:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.accreditorName ? values.accreditorName : "-" }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Accreditor's Geolocation:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values?.region?.name ?? "-"
              }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Accreditor's Ownership:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.accredatorOwnership ? values.accredatorOwnership.name : "-"
              }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Accreditor's Director Name:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.accreditorDirectorName
                    ? values.accreditorDirectorName
                    : "-"
              }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Accreditor's Director Email Address:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.accreditorDirectorEmail
                    ? values.accreditorDirectorEmail
                    : "-"
              }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Accreditor's Director Phone Number:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{
                values.accreditorDirectorPhone
                    ? values.accreditorDirectorPhone
                    : "-"
              }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Institutional Email:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.institutionalEmail ? values.institutionalEmail : "-" }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              Institutional Phone Number:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.institutionalPhone ? values.institutionalPhone : "-" }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Accreditation Date:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.accreditationDate ? values.accreditationDate : "-" }}
            </div>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Accreditation Code:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.accreditationCode ? values.accreditationCode : "-" }}
            </div>
          </div>
        </div>
        <div class="flex my-4 mb-4">

          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Accredator's Status:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              <span style="float: right">
                <v-chip :color="getColor(values.isActive)" dark>
                  {{ values.isActive == true ? "Active" : "Not Active" }}
                </v-chip>
              </span>
            </div>
          </div>
          <div class="w-1/2 h-12"></div>
          <div class="w-1/2 h-12"></div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    accreditor: Object,
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    if (this.accreditor != null) {
      this.values = this.accreditor;
    }
  },
  methods: {
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
  },
};
</script>
